import { CSSProperties, FC } from 'react';
import { EmptyStateIconWrapper, LastQueriesEmptyStateWrapper } from './EmptyState.styles';
import { AllieSaveOutlineIcon } from '../../../../../styling/icons';
import { AllieText } from '../../../../../components';

interface AllieLastQueriesEmptyStateProps {
  emptyMessage: string;
  style?: CSSProperties
}

export const AllieLastQueriesEmptyState: FC<AllieLastQueriesEmptyStateProps> = ({
  emptyMessage,
  style
}) => {
  return (
    <LastQueriesEmptyStateWrapper style={style}>
      <EmptyStateIconWrapper>
        <AllieSaveOutlineIcon style={{ fontSize: 24, color: 'var(--allie-color-neutral-50)' }} />
      </EmptyStateIconWrapper>
      <AllieText type="body2" color="neutral-60">
        {emptyMessage}
      </AllieText>
    </LastQueriesEmptyStateWrapper>
  );
};
